export default __webpack_public_path__ + "281ae4e297fb7a575a6f93ed7a61f2dd.png";